const Constants = {

  applicationName: 'RansomStop',

  customerName: 'blackclover',
  apiHost: 'blackclover-api',
  domainName: 'ransomstop.com',
  version: '2.3.1',
  userPoolId: 'us-east-1_3LSRQtRbZ',
  userPoolClientId: '7ldgh93ej0jcoqqd4kt6gai4g8',
  authDomain: 'blackclover-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',
  showBilling: true,

}
export default Constants
